.icon-add pes-icon {
  opacity: 0.7;
}

pes-icon {
  color: #333333;
}